import { FC } from "react";
import { Box, Tooltip, Typography } from "@material-ui/core";
import { DsmIcon } from "@dsm-dcs/design-system-react";
// eslint-disable-next-line import/extensions
import { roiResultsStyles } from "../../../../ThemeProvider";
import PercentageBadge from "./PercentageBadge";

interface MetricRowProps {
  title: string;

  label?: string;
  tooltip: string;

  value?: string;
  percentageChange?: number;

  unavailableMessage?: string;
}

const MetricRow: FC<MetricRowProps> = ({
  title,
  label,
  tooltip,
  value,
  percentageChange,
  unavailableMessage,
}) => {
  const classes = roiResultsStyles();

  return (
    <Box className={classes.metricCard}>
      <Box className={classes.metricLeft}>
        <Typography className={classes.metricTitle}>{title}</Typography>

        {label && (
          <>
            <Box className={classes.metricDivider} />
            <Typography className={classes.metricLabel}>{label}</Typography>
          </>
        )}

        <Tooltip title={tooltip} arrow>
          <DsmIcon
            name="general/help-circle"
            className={classes.metricHelpIcon}
          />
        </Tooltip>
      </Box>

      <Box className={classes.metricRight}>
        {value !== undefined ? (
          <>
            <Typography className={classes.metricValue}>{value}</Typography>
            {percentageChange !== undefined && (
              <PercentageBadge value={percentageChange} />
            )}
          </>
        ) : (
          unavailableMessage && (
            <Typography className={classes.metricNotAvailable}>
              {unavailableMessage}
            </Typography>
          )
        )}
      </Box>
    </Box>
  );
};

export default MetricRow;
